import React from 'react';
import CompanyAddressScreen from './screens/CompanyAddressScreen/CompanyAddressScreen';

function WelcomeAddress() {
  return <CompanyAddressScreen />;
}

export default WelcomeAddress;
